import { ClickRedirectTypeSchema as i, DomainNameSchema as t, CampaignStatusSchema as u, CampaignGroupIdSchema as o, AdTypeSchema as S, UserIdSchema as h } from "@hprofits/shared";
import { z as e } from "zod";
import "../ad-group/contract.js";
import { PricingRuleSetDetailedStatusSchema as g, AdGroupListSchema as C, AdGroupSchema as l, PricingRuleOutputSchema as y } from "../ad-group/schemas.js";
import "@hprofits/shared/errors";
import "@hprofits/utils/zod";
import { createViewSchemas as r } from "../common/acl-view.js";
import "@hprofits/utils";
import "@orpc/contract";
import "@orpc/openapi";
import "../swagger/security.js";
import "../swagger/tags.js";
import { OwnerSchema as G } from "../common/owner.js";
import "../common/params.js";
import { paginatedList as A, PaginationSchema as w, SortingSchema as L } from "../common/pagination.js";
import "../creative-group/contract.js";
import { CreativeGroupListSchema as b, CreativeGroupCommonViewSchema as x } from "../creative-group/schemas.js";
import "../target-group/contract.js";
import { TargetGroupListSchema as f, TargetGroupListViewSchema as I } from "../target-group/schemas.js";
const m = 30, c = e.string().trim().min(1, "name must be non-empty").max(m, `name must be at most ${m} characters`), n = e.object({
  clickRedirectType: i
}).strict(), T = n.readonly(), M = n.extend({
  redirectDomain: t.optional()
}).readonly(), me = e.union([T, M]), p = n.extend({
  name: c
}), R = p.readonly(), V = p.extend({
  redirectDomain: t.optional()
}).readonly(), ie = e.union([R, V]), oe = e.object({
  name: c
}).readonly(), s = e.object({
  id: o,
  name: e.string().trim().min(1, "name must be non-empty").max(30),
  createdAt: e.coerce.date(),
  status: u,
  detailedStatus: g
}).readonly(), d = e.object({
  owner: G,
  updatedAt: e.coerce.date()
}).readonly(), {
  common: re,
  admin: ce,
  union: j
} = r(s, d), pe = A(j), k = e.object({
  name: e.string().trim().min(1, "name must be non-empty").optional(),
  ownerId: e.union([e.coerce.number().pipe(h), e.string().trim().min(1)]).optional(),
  recentlyCreated: e.preprocess((a) => a === "true" ? !0 : a === "false" ? !1 : a, e.boolean()).optional(),
  adUnitTypes: e.array(e.coerce.string().pipe(S)).optional()
}), se = w.extend(L.shape).extend(
  k.shape
), F = s.unwrap().extend({
  clickRedirectType: i,
  adGroups: C,
  targetGroups: f,
  creativeGroups: b
}).readonly(), D = d.unwrap().extend({
  redirectDomain: t.optional()
}).readonly(), {
  common: de,
  admin: ue,
  union: Se
} = r(F, D), N = I.unwrap().pick({
  id: !0,
  name: !0
}).readonly(), v = x.unwrap().pick({
  id: !0,
  name: !0,
  adType: !0,
  adFormat: !0
}).extend({ assetsCount: e.number().int().nonnegative() }).readonly(), P = l.unwrap().pick({
  id: !0,
  name: !0
}), B = P.extend({
  pricingRules: e.array(y).readonly()
}).readonly(), he = e.object({
  campaignId: o,
  targetGroups: e.array(N).readonly(),
  creativeGroups: e.array(v).readonly(),
  adGroups: e.array(B).readonly()
}).readonly();
export {
  m as CAMPAIGN_NAME_MAX_LENGTH,
  M as CampaignAdminMutationSchema,
  ue as CampaignAdminViewSchema,
  T as CampaignCommonMutationSchema,
  de as CampaignCommonViewSchema,
  k as CampaignListFilterSchema,
  d as CampaignListItemAdminFieldsSchema,
  ce as CampaignListItemAdminViewSchema,
  s as CampaignListItemCommonFieldsSchema,
  re as CampaignListItemCommonViewSchema,
  j as CampaignListItemSchema,
  se as CampaignListQuerySchema,
  pe as CampaignListSchema,
  me as CampaignMutationSchema,
  Se as CampaignSchema,
  B as CampaignStatisticsAdGroupSchema,
  v as CampaignStatisticsCreativeGroupSchema,
  he as CampaignStatisticsSchema,
  N as CampaignStatisticsTargetGroupSchema,
  V as CreateCampaignAdminSchema,
  R as CreateCampaignCommonSchema,
  ie as CreateCampaignSchema,
  oe as RenameCampaignSchema
};
//# sourceMappingURL=schemas.js.map
